import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, SFNotification } from 'utils/types';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import UpcomingContainer from './UpcomingContainer';
import EditAppointmentContainer from './edit/appointment/EditAppointmentContainer';
import NotFound from 'common/NotFound';
import { withNotification } from 'common/withNotification';
import { hot } from 'react-hot-loader';

class App extends React.Component {

  get router() {
    return (
      <Router>
        <Switch>
          <Route
            exact path="/"
            render={() => <UpcomingContainer {...this.props} />}
          />
          <Route
            exact path="/appointment/:id"
            render={({ match }) => <EditAppointmentContainer {...this.props} id={match.params.id} />}
          />
          <Route component={NotFound} />
        </Switch>
      </Router>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.props.notification.render()}
        {this.router}
      </React.Fragment>
    )
  }
}

App.defaultProps = {
  timeZone: "America/New_York"
};

App.propTypes = {
  timeZone: PropTypes.string,
  partyId: SFEntityID.isRequired,
  notification: SFNotification.isRequired
};

export default hot(module)(withNotification(App));
